// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "compiled-css" + "." + "31b5e5a349dfe51aebe0" + ".css";
};